/**
 * EventHelper API
 * API fournie par NetExpo liée à la gestion interne des événements
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Entreprise } from '../model/entreprise';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EntreprisesService {

    protected basePath = 'http://localhost:3000';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Chercher une entreprise pour un événement
     * EX_106
     * @param evenementId identifiant unique d&#x27;un evenement
     * @param entrepriseId identifiant unique d&#x27;une entreprise
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCompanyByEventId(evenementId: number, entrepriseId: number, observe?: 'body', reportProgress?: boolean): Observable<Entreprise>;
    public getCompanyByEventId(evenementId: number, entrepriseId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Entreprise>>;
    public getCompanyByEventId(evenementId: number, entrepriseId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Entreprise>>;
    public getCompanyByEventId(evenementId: number, entrepriseId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (evenementId === null || evenementId === undefined) {
            throw new Error('Required parameter evenementId was null or undefined when calling getCompanyByEventId.');
        }

        if (entrepriseId === null || entrepriseId === undefined) {
            throw new Error('Required parameter entrepriseId was null or undefined when calling getCompanyByEventId.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Entreprise>('get',`${this.basePath}/evenements/${encodeURIComponent(String(evenementId))}/entreprises/${encodeURIComponent(String(entrepriseId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
